// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.searchIcon[data-v-32ec3078]{\n    margin-right: -12px;\n    display: inline-block;\n    border-radius: 0 5px 5px 0;\n    overflow: hidden;\n    cursor: pointer;\n}\n[data-v-32ec3078] .form-select.v-text-field--outlined .v-select__selections{\n  display: flex !important;\n}\n\n", ""]);
// Exports
module.exports = exports;
